import { useNotify } from "react-admin";

export const useExport = () => {
  const notify = useNotify();

  const handleExportFile = (fileBlob: Blob, title: string) => {
    try {
      if (!(fileBlob instanceof Blob)) {
        throw new Error("fileBlob must be a Blob");
      }
      if (typeof title !== "string") {
        throw new Error("title must be a string");
      }
      const url = window.URL.createObjectURL(fileBlob);
      const link = document.createElement("a");
      link.href = url;
      link.download = title;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error: any) {
      console.error("Error exporting:", error);
      notify(`Error exporting: ${error.message}`, { type: "error" });
    }
  };

  const handleExportJson = (data: any, title: string) => {
    try {
      const jsonString = JSON.stringify(data, null, 2);
      const blob = new Blob([jsonString], { type: "application/json" });
      handleExportFile(blob, title);
    } catch (error) {
      console.error("Error exporting:", error);
      notify("Error exporting:", { type: "error" });
    }
  };

  return {
    handleExportJson,
    handleExportFile,
  };
};
